/**
 * BookingStatusPill — the shared booking status pill (BON-130).
 *
 * Tailwind-native (moss / water / clay / stone / pending tokens), so it renders
 * correctly ANYWHERE — unlike the `.nb-dashboards`-scoped StatusPill primitive,
 * which only styles inside that scope. Dot + label, matching the mock. Tone
 * comes from {@link displayStatus} in bookingListModel.
 */
import type { BookingListItem } from '../../api/bookingsList';

import { displayStatus, type PillTone } from './bookingListModel';

const TONE: Record<PillTone, { badge: string; dot: string }> = {
  moss: {
    badge: 'bg-moss-50 text-moss-700 dark:bg-moss-900/30 dark:text-moss-300',
    dot: 'bg-moss-500',
  },
  water: {
    badge: 'bg-water-50 text-water-700 dark:bg-water-900/30 dark:text-water-300',
    dot: 'bg-water-500',
  },
  clay: {
    badge: 'bg-clay-50 text-clay-700 dark:bg-clay-900/30 dark:text-clay-300',
    dot: 'bg-clay-500',
  },
  stone: {
    badge: 'bg-stone-100 text-stone-600 dark:bg-stone-700/60 dark:text-stone-300',
    dot: 'bg-stone-400',
  },
  pending: {
    badge: 'bg-pending-50 text-pending-700 dark:bg-pending-900/30 dark:text-pending-300',
    dot: 'bg-pending-500',
  },
};

export function BookingStatusPill({
  booking,
}: {
  booking: Pick<BookingListItem, 'status' | 'isComp'>;
}) {
  const { label, tone } = displayStatus(booking);
  const c = TONE[tone];
  return (
    <span
      data-tone={tone}
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-medium ${c.badge}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${c.dot}`} />
      {label}
    </span>
  );
}
